export const PARTICIPATE_GROUP_SUCCESS_MSG = "グループの参加に成功しました";

// TODO : fix message
export const REGISTER_ANSWERS_SUCCESS_MSG = "回答を送信しました";
export const REGISTER_ANSWERS_FAILURE_MSG = "回答を送信できませんでした";
export const OPPA_CONTENTS_TOO_LONG_MSG = "2000文字以内で入力してください。";
export const CREATE_COMMENT_SUCCESS_MSG = "コメントを送信しました";
export const UPDATE_COMMENT_SUCCESS_MSG = "コメントを更新しました";
export const DELETE_COMMENT_SUCCESS_MSG = "コメントを削除しました";
export const UPDATE_STUDENT_PASSWORD_SUCCESS_MESSAGE =
  "パスワードの更新に成功しました";
export const UPDATE_SURVEY_SUCCESS_MSG = "回答の送信に成功しました";
export const UPDATE_SURVEY_FAILURE_MSG = "回答の送信に失敗しました";
export const SUBMIT_REALIZATION_SUCCESS_MSG = "保存しました";
export const SUBMIT_REALIZATION_FAILURE_MSG =
  "保存に失敗しました。もう一度お試しください。";
export const UPDATE_PHOTO_SUCCESS_MESSAGE = "画像を更新しました";
export const UPDATE_PHOTO_FAILURE_MESSAGE = "画像の更新に失敗しました";
export const FETCH_FAILURE_MESSAGE = "データ取得に失敗しました";
